import { ValidAddressRegex } from "../../utils/regex.utils";
import { FieldValidationParams } from "../types";
import { validationException } from "./validator.utils";

export const validateAddressField = async ({
  args,
  names,
  onValidated,
  onInvalid,
  onValidationStarted,
}: FieldValidationParams) => {
  return new Promise((resolve, reject) => {
    const [_inputFormat, value, _defs, schema] = args;
    const { instancePath } = schema;
    const paths = (instancePath || "").split("/");
    const name = paths[paths.length - 1];

    if (onValidationStarted) {
      onValidationStarted("address", name);
    }
    const regex = ValidAddressRegex;
    const isValid = regex.test(value);
    if (isValid) {
      if (onValidated) {
        onValidated(names, name, "address", []);
      }
      return resolve(true);
    }
    if (onInvalid) {
      onInvalid(names, name, "address", 0, []);
    }
    return reject(validationException("address", "Invalid Address."));
  });
};
